<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12>
        <h1 class="headline">Liste des fours</h1>

        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4 lg3 xl2 v-for="oven in ovens" v-bind:key="oven.id">
              <v-card height="100%" class="primary--text">
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn dark color="primary" small flat @click="removeOvenConfirm(oven)">
                    <v-icon left>delete</v-icon>four
                  </v-btn>
                </v-card-actions>
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0">{{ oven.name}}</h3>
                    <div>{{ oven.macAddress }}</div>
                    <div class="font-weight-bold">
                      {{ oven.serialNumber || "N° SÉRIE INCONNU" }}
                      <v-btn icon small flat color="primary" @click="editSerial(oven)">
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-card-title>

                <v-card-text class="pt-0 pb-0">
                  <!-- Listing des utilisateurs -->

                  <v-list v-if="oven.owners.length > 0">
                    <v-list-tile
                      class="blue--text"
                      v-for="user in oven.owners "
                      v-bind:key="user.id"
                    >
                      <v-list-tile-action>
                        <v-btn icon @click="detachUserConfirm(oven, user)">
                          <v-icon color="blue">remove_circle</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ user.name }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card-text>

                <v-card-actions>
                  <v-btn dark block color="blue" @click="addUser(oven)">
                    <v-icon left>add_circle</v-icon>utilisateur
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    <!-- Dialog d'ajout d'utilisateur -->
    <v-dialog v-model="addUserDialog" persistent max-width="600px">
      <UserAdd @close="addUserDialog = false" @reload="loadOvenList()" :oven="selectedOven"></UserAdd>
    </v-dialog>
  </v-container>
</template>


<script>
import UserAdd from "../components/OvensAddUser";
export default {
  components: {
    UserAdd
  },
  data: () => ({
    ovens: [],
    selectedOven: null,
    addUserDialog: false
  }),
  methods: {
    // chargement de la liste des fours enregistrés
    loadOvenList() {
      this.api
        .get("/admin/ovens")
        .then(res => {
          this.ovens = res.data;
        })
        .catch(err => {
          console.error(err.message);
        });
    },
    // ajouter un utilisateur
    addUser(oven) {
      this.selectedOven = oven;
      this.addUserDialog = true;
    },
    // dialog de confirmation pour détacher un utilisateur
    detachUserConfirm(oven, user) {
      // nom du four
      var ovenName = oven.name;
      if (!ovenName) {
        ovenName = oven.macAddress;
      }

      if (
        window.confirm(
          "Détacher l'utilisateur " + user.name + " du four " + ovenName + " ? "
        )
      ) {
        this.detachUser(oven, user);
      }
    },
    // détache un utilisateur
    detachUser(oven, user) {
      this.api
        .patch("/admin/ovens/" + oven.id + "/users/" + user.id + "/unrelate")
        .then(() => {
          this.loadOvenList();
        })
        .catch(err => {
          console.error(err);
        });
    },
    // confirmation suppression de four
    removeOvenConfirm(oven) {
      // nom du four
      var ovenName = oven.name;
      if (!ovenName) {
        ovenName = oven.macAddress;
      }

      if (window.confirm("Supprimer le four " + ovenName + " ? ")) {
        this.removeOven(oven);
      }
    },
    // supprimer un four
    removeOven(oven) {
      this.api
        .delete("/admin/ovens/" + oven.id)
        .then(() => {
          this.loadOvenList();
        })
        .catch(err => {
          console.error(err);
        });
    },
    // édition du numéro de série
    editSerial(oven) {
      // nom du four
      var ovenName = oven.name;
      if (!ovenName) {
        ovenName = oven.macAddress;
      }
      // valeur du numéro
      var def = "";
      if (oven.serialNumber) {
        def = oven.serialNumber;
      }
      var serialNumber = window.prompt(
        "Quelle est le numéro de série du four " + ovenName + " ?",
        def
      );
      // enregistre le numéro de série
      this.api
        .patch("/admin/ovens/" + oven.id + "/", {
          serialNumber: serialNumber
        })
        .then(() => {
          this.loadOvenList();
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  mounted() {
    this.loadOvenList();
  }
};
</script>


<style>
</style>
